export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_IS_WEBP = 'SET_IS_WEBP';
export const SET_IS_GOOGLE_MAPS = 'SET_IS_GOOGLE_MAPS';
export const SET_IS_404 = 'SET_IS_404';
export const SET_COOKIES_ACCEPTED = 'SET_COOKIES_ACCEPTED';
export const SCHOLARSHIP_HIDE_ALERT = 'SCHOLARSHIP_HIDE_ALERT';
